import { getTexture } from "../Services/transferData"

export const getAllTexture = () =>{
    return async (dispatch) => {
        const {data} = await getTexture();
        await dispatch({type:"GET_TEXTURE",payload:data});
    };
};